import {
  ClockCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { StatusPage } from "./StatusPage";
import { Stored, useCustomOidc } from "./customOidcUtils";

export const SessionLostComponent = ({ isAuthenticationError = false }) => {
  //
  const dispatch = useDispatch();
  const { isAuthenticated } = useCustomOidc();
  const location = useLocation();

  //
  const onStorageUpdate = (e) => {
    const { key, oldValue, newValue } = e;
    if (
      key === Stored.LAST_LOGIN_TIMESTAMP &&
      oldValue !== newValue &&
      newValue != null
    ) {
      console.log(
        "User login detected. Refreshing web page. Timestamp:",
        newValue
      );

      sessionStorage.setItem(Stored.LOAD_ACTOR, Stored.DEFAULT_VALUE);

      // Navigate to the home page
      window.location.replace(`${process.env.REACT_APP_URI}/home`);
    }
  };

  //
  useEffect(() => {
    if (isAuthenticated !== true) {
      console.log("Not authenticated so registering storage listeners");
      window.addEventListener("storage", onStorageUpdate);
      return () => {
        window.removeEventListener("storage", onStorageUpdate);
      };
    }
  }, [isAuthenticated]);

  const isTempOutage = process.env.REACT_APP_TEMP_OUTAGE;

  // Move to /logout if SessionLostComponent is displayed but the page is not /logout
  if (location.pathname !== "/logout") {
    return <Navigate to="/logout" replace={true} />;
  }

  const content =
    isAuthenticationError === true
      ? {
          icon: <CloseCircleOutlined />,
          tone: "error",
          title: "We couldn't complete your sign-in",
          message: "Try signing in again. If it keeps failing, contact support.",
          buttonLabel: "Try again",
          extra: (
            <>
              <span className="status-page-extra-header">
                <InfoCircleOutlined className="status-page-extra-icon" />
                Having trouble signing in recently?
              </span>
              <p className="status-page-extra-message">
                This may be caused by your computer's time zone settings.{" "}
                <a
                  href="https://brokerlink.atlassian.net/wiki/spaces/AKB/pages/2562162689/Autolink+Login+Issues+After+November+1+Time+Zone+Changes"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View troubleshooting steps
                </a>{" "}
                before contacting support.
              </p>
            </>
          ),
        }
      : localStorage.getItem(Stored.PRESSED_LOGOUT) === Stored.DEFAULT_VALUE
      ? {
          icon: <LogoutOutlined />,
          title: "You've signed out",
          message: "Sign in again whenever you're ready.",
          buttonLabel: "Sign in",
          signInHint: true,
        }
      : {
          icon: <ClockCircleOutlined />,
          title: "You were signed out after a period of inactivity",
          message: "Sign in again to continue.",
          buttonLabel: "Sign in",
          signInHint: true,
        };

  return (
    <StatusPage
      {...content}
      notice={
        isTempOutage === "true" && (
          <>
            <b>Temporary outage.</b> We're working to restore service as
            quickly as possible.
          </>
        )
      }
      onButtonClick={() => {
        if (!isAuthenticated) {
          dispatch({ type: "CLEAR_REDUX_STORE" });
        }
        window.location.replace(`${process.env.REACT_APP_URI}/home`);
      }}
    />
  );
};

